import { memo, useCallback, useMemo, useState } from "react";
import Modal from "components/shared/modal";
import SearchForm from "components/form-generator/search-form/search-form";
import { useLocation, useNavigate } from "react-router-dom";
import { urlDecoder, urlEncoder } from "utils";

const Searchbox = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);

    const [showModal, setShowModal] = useState(false);
    const [value, setValue] = useState(urlParams.get("text") ? urlDecoder(urlParams.get("text")) : "");

    const closeModal = useCallback(() => {
        setShowModal(false);
    }, [])

    const submitHandler = e => {
        e.preventDefault();

        if (value.length)
            urlParams.set("text", urlEncoder(value));
        else
            urlParams.delete("text");

        navigate(`?${urlParams.toString()}`);
    }

    const fields = useMemo(() => {
        return [
            {
                "caption": "فرم مورد نظر",
                "name": "form_id",
                "data_type": 2,
                "input_type": 17,
                "value": "",
                "masterclass": "half-row",
                "setting": {
                    "get_url": "/api/form/list?id=:id&parent_child=true",
                    "search_url": "/api/form/list_by_module_id?id=1&key=:key",
                    "value_key": "id",
                    "label_key": "title"
                }
            },
            {
                "caption": "دسته مورد نظر",
                "name": "categories",
                "data_type": 6,
                "input_type": 18,
                "value": "",
                "masterclass": "half-row",
                "setting": {
                    "get_url": "/api/category/list?id=:id&parent_child=true",
                    "search_url": "/api/category/list?key=:key&parent_child=true",
                    "value_key": "id",
                    "label_key": "title"
                }
            },
        ]
    }, [])

    return (
        <>
            <div className="searchbox-c1">
                <form onSubmit={submitHandler}>
                    <div className="flex h-10 field">
                        <input
                            type="text"
                            className="tp-23 rounded-tr-md rounded-br-md text-sm px-4 w-44 focus:w-72 transition-all"
                            placeholder="جستجو ..."
                            value={value}
                            onChange={e => setValue(e.target.value)}
                        />

                        <button
                            type="button"
                            className="h-10 w-10 bg-primary-100 rounded-tl-md rounded-bl-md text-white fit-center hover:bg-primary-200 transition-colors"
                            onClick={() => setShowModal(true)}
                        >
                            <i className="fa-solid fa-filter"></i>
                        </button>
                    </div>
                </form>
            </div>

            <Modal show={showModal} title="فیلتر ها" closeHandler={closeModal} className="search-modal">
                <SearchForm fields={fields} doneCallback={closeModal} />
            </Modal>
        </>
    )
}

export default memo(Searchbox);   